import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/Index'
import Login from '@/views/Login'

import store from '@/store'
import { AuthAPI } from '@/api'
import DashboardRouter from './dashboard/dashboard.router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Index,
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    DashboardRouter,
  ]
})

router.beforeEach(async (to, from, next) => {
  if(!store.getters['user/isLoaded']) {
    if(store.getters['user/token']) {
      await AuthAPI.getData(store.getters['user/token'])
        .then(res => {
          store.commit('user/auth', store.getters['user/token']);
          store.commit('user/saveData', res.data);
        })
        .catch(err => {
          console.error('Invalid auth token.');
        });
    }
    store.commit('user/load');
  }

  if(!store.getters['on-load/isLoaded'] && store.getters['user/isLogged']) {
    await store.dispatch('on-load/updateData');
  }

  next();
});

export default router;
